import BaseModel from './BaseModel';
export default class VinWonderTicket extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id;
        this.vinWonderId = data.vinWonderId;
        this.name = data.name || this.translate.name || undefined;
        this.shortDescriptions = data.shortDescriptions || this.translate.shortDescriptions || undefined;
        this.descriptions = data.descriptions || this.translate.descriptions || undefined;
        this.ticketCode = data.ticketCode || this.translate.ticketCode || undefined;
        this.vinWonderTicketItems = data.vinWonderTicketItems || [];
        this.isAvailable = data.isAvailable || false;
        this.createdDate = data.createdDate || undefined
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            vinWonderId: this.vinWonderId,
            name: this.name,
            shortDescriptions: this.shortDescriptions,
            descriptions: this.descriptions,
            // ticketCode: this.ticketCode,
            isAvailable: this.isAvailable
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id,
                vinWonderTicketId: this.translate.vinWonderTicketId || this.id,
                name: this.name,
                shortDescriptions: this.shortDescriptions,
                descriptions: this.descriptions,
                languageCode: this.languageCode,
            }
        }
        return result;
    }

}

export class VinWonderTicketItems {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined;
        this.vinWonderTicketId = data.vinWonderTicketId || undefined;
        this.ticketType = data.ticketType || undefined;
        this.refId = data.refId || undefined;
        this.originalPrice = data.originalPrice || undefined;
        this.salePrice = data.salePrice || undefined;
    }
    export() {
        const result = super.export({
            id: this.id,
            vinWonderId: this.vinWonderId,
            ticketType: this.ticketType,
            refId: this.refId,
            originalPrice: this.originalPrice,
            salePrice: this.salePrice
        });
        return result
    }
}
